// Source https://css-tricks.com/how-to-animate-the-details-element-using-waapi/

const Accordion = () => {
  const defs = {
    selectors: {
      accordion: ".js-accordion",
      accordionContent: ".js-accordion-content",
    },
    vars: {
      get duration() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 250;
      },
      easing: "ease-in-out",
    },
  };

  const init = () => {
    const accordions = document.querySelectorAll(defs.selectors.accordion);
    accordions.forEach((accordion) => {
      const obj = {
        element: accordion,
        id: accordion.dataset.id,
        summary: accordion.querySelector("summary"),
        content: accordion.querySelector(defs.selectors.accordionContent),
        animation: null,
        isClosing: false,
        isExpanding: false,
      };
      obj.summary?.addEventListener("click", (e) => {
        onClick(e, obj);
      });
    });
  };

  const onClick = (e, obj) => {
    // Stop default behaviour from the browser
    e.preventDefault();
    // Add an overflow on the <details> to avoid content overflowing
    obj.element.style.overflow = "hidden";
    // Check if the element is being closed or is already closed
    if (obj.isClosing || !obj.element.open) {
      open(obj);
      // Check if the element is being opened or is already open
    } else if (obj.isExpanding || obj.element.open) {
      shrink(obj);
    }
  };

  const shrink = (obj) => {
    // Remove the class immediately when starting to close
    obj.element.classList.remove("accordion--open");

    // Set the element as "being closed"
    obj.isClosing = true;

    // Store the current height of the element
    const startHeight = `${obj.element.offsetHeight}px`;
    // Calculate the height of the summary
    const endHeight = `${obj.summary?.offsetHeight}px`;

    // If there is already an animation running
    if (obj.animation !== null) {
      // Cancel the current animation
      obj.animation.cancel();
    }

    // Start a WAAPI animation
    obj.animation = obj.element.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: defs.vars.duration,
        easing: defs.vars.easing,
      }
    );

    // When the animation is complete, call onAnimationFinish()
    obj.animation.onfinish = () => {
      onAnimationFinish(false, obj);
    };
    // If the animation is cancelled, isClosing variable is set to false
    obj.animation.oncancel = () => {
      obj.isClosing = false;
    };
  };

  const open = (obj) => {
    // Add the class immediately when starting to open
    obj.element.classList.add("accordion--open");
    // Apply a fixed height on the element
    obj.element.style.height = `${obj.element.offsetHeight}px`;
    // Force the [open] attribute on the details element
    obj.element.open = true;
    // Wait for the next frame to call the expand function
    window.requestAnimationFrame(() => {
      expand(obj);
    });
  };

  const expand = (obj) => {
    if (obj.summary === null || obj.content == null) return;
    // Set the element as "being expanding"
    obj.isExpanding = true;
    // Get the current fixed height of the element
    const startHeight = `${obj.element.offsetHeight}px`;
    // Calculate the open height of the element (summary height + content height)
    const endHeight = `${obj.summary.offsetHeight + obj.content.offsetHeight}px`;

    // If there is already an animation running
    if (obj.animation !== null) {
      // Cancel the current animation
      obj.animation.cancel();
    }

    // Start a WAAPI animation
    obj.animation = obj.element.animate(
      {
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight],
      },
      {
        duration: defs.vars.duration,
        easing: defs.vars.easing,
      }
    );

    // When the animation is complete, call onAnimationFinish()
    obj.animation.onfinish = () => {
      onAnimationFinish(true, obj);
    };
    // If the animation is cancelled, isExpanding variable is set to false
    obj.animation.oncancel = () => {
      obj.isExpanding = false;
    };
  };

  const onAnimationFinish = (open, obj) => {
    // Set the open attribute based on the parameter
    obj.element.open = open;
    // Add/remove animation complete class
    if (open) {
      obj.element.classList.add("accordion--open");
    } else {
      obj.element.classList.remove("accordion--open");
    }
    // Clear the stored animation
    obj.animation = null;
    // Reset isClosing & isExpanding
    obj.isClosing = false;
    obj.isExpanding = false;
    // Remove the overflow hidden and the fixed height
    obj.element.style.height = obj.element.style.overflow = "";
  };

  return {
    init,
  };
};

export default Accordion;
